import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };
  if (!isOpen) return null;
  return <div ref={overlayRef} onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-[#4a2535]/40 backdrop-blur-sm p-4 animate-in fade-in duration-200" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-185">
      <div ref={contentRef} className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-[#FFF5F7] rounded-xl shadow-2xl border border-[#f0d0dc] animate-in zoom-in-95 duration-200" data-id="element-186">
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-[#FFF5F7] border-b border-[#f0d0dc]" data-id="element-187">
          <h2 id="modal-title" className="text-2xl font-bold text-[#4a2535] font-serif" data-id="element-188">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-[#7a5568] hover:text-[#c4607a] transition-colors rounded-full hover:bg-[#c4607a]/10" aria-label="Cerrar" data-id="element-189">
            <X size={24} data-id="element-190" />
          </button>
        </div>

        <div className="p-6 md:p-8 text-[#4a2535] font-serif leading-relaxed" data-id="element-191">
          {children}
        </div>
      </div>
    </div>;
}